import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "./api";
import type { Backlink } from "./types";
export function Backlinks({
  projectId,
  type,
  id,
  version,
  onOpen,
}: {
  projectId: string;
  type: "document" | "entity";
  id: string;
  version: number;
  onOpen: (link: Backlink) => void;
}) {
  const [links, setLinks] = useState<Backlink[]>([]),
    [error, setError] = useState("");
  useEffect(() => {
    const c = new AbortController();
    api<Backlink[]>(`/projects/${projectId}/references?type=${type}&id=${id}`, {
      signal: c.signal,
    })
      .then((v) => {
        setLinks(v);
        setError("");
      })
      .catch((e) => {
        if (e.name !== "AbortError") setError(e.message);
      });
    return () => c.abort();
  }, [projectId, type, id, version]);
  return (
    <div className="inspector-group">
      <span className="eyebrow">ГДЕ ИСПОЛЬЗУЕТСЯ</span>
      {error ? (
        <p className="small-text muted">{error}</p>
      ) : links.length ? (
        <div className="backlinks">
          {links.map((l) => (
            <button key={l.type + l.id} onClick={() => onOpen(l)}>
              <span>
                {l.title}
                <small>
                  {l.type === "board"
                    ? "Доска"
                    : l.type === "entity"
                      ? "Сущность"
                      : "Документ"}
                </small>
              </span>
              <ArrowUpRight size={14} />
            </button>
          ))}
        </div>
      ) : (
        <p className="small-text muted">Связей пока нет.</p>
      )}
    </div>
  );
}
